var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: {
        form: _vm.form,
        rules: _vm.rules,
        "label-width": "120px",
        width: "800px",
      },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c(
        "BjDivider",
        {
          scopedSlots: _vm._u([
            {
              key: "right",
              fn: function () {
                return [
                  _vm.isEdit
                    ? _c("BjLogButton", {
                        attrs: {
                          id: _vm.form.id,
                          permission: "BusinessChannelPhysicalList_Log",
                          title: _vm.form.name,
                          api: "stockApi",
                        },
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_vm._v(_vm._s(_vm.$t("WarehouseManagement.form.Basic")) + " ")]
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("WarehouseManagement.form.name"),
                    prop: "name",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      maxlength: _vm.MAX_LENGTH.DEFAULT,
                      placeholder: _vm.$t("inputText"),
                    },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("BjFormItemCode", {
                attrs: {
                  readonly: _vm.isEdit,
                  label: _vm.$t("WarehouseManagement.form.code"),
                  prop: "code",
                },
                model: {
                  value: _vm.form.code,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "code", $$v)
                  },
                  expression: "form.code",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("WarehouseManagement.form.Contact"),
                    prop: "contactName",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      maxlength: _vm.MAX_LENGTH.DEFAULT,
                      placeholder: _vm.$t("inputText"),
                    },
                    model: {
                      value: _vm.form.contactName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "contactName", $$v)
                      },
                      expression: "form.contactName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("BjFormItemMobile", {
                attrs: {
                  prop: "contactPhone",
                  label: _vm.$t("WarehouseManagement.form.phone"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.contactPhone,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "contactPhone", $$v)
                  },
                  expression: "form.contactPhone",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("WarehouseManagement.form.districtName"),
                    prop: "districtName",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      maxlength: _vm.MAX_LENGTH.DEFAULT,
                      placeholder: _vm.$t("inputText"),
                    },
                    model: {
                      value: _vm.form.districtName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "districtName", $$v)
                      },
                      expression: "form.districtName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("WarehouseManagement.form.Detailed"),
                    prop: "detailAddress",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      maxlength: _vm.MAX_LENGTH.DEFAULT,
                      placeholder: _vm.$t("WarehouseManagement.form.Detailed"),
                    },
                    model: {
                      value: _vm.form.detailAddress,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "detailAddress", $$v)
                      },
                      expression: "form.detailAddress",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("WarehouseManagement.form.city"),
                    prop: "cityName",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      maxlength: _vm.MAX_LENGTH.DEFAULT,
                      placeholder: _vm.$t("inputText"),
                    },
                    model: {
                      value: _vm.form.cityName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "cityName", $$v)
                      },
                      expression: "form.cityName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("WarehouseManagement.form.country"),
                    prop: "fullAddress",
                  },
                },
                [
                  _c("BjRegionCascader", {
                    staticClass: "full-width",
                    attrs: { "is-array": "", clearable: "" },
                    on: { change: _vm.countryData },
                    model: {
                      value: _vm.regionList,
                      callback: function ($$v) {
                        _vm.regionList = $$v
                      },
                      expression: "regionList",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("WarehouseManagement.form.postcode"),
                    prop: "postcode",
                  },
                },
                [
                  _c("BjInputCode", {
                    attrs: {
                      maxlength: _vm.MAX_LENGTH.DEFAULT,
                      placeholder: _vm.$t("inputText"),
                    },
                    model: {
                      value: _vm.form.postcode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "postcode", $$v)
                      },
                      expression: "form.postcode",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("WarehouseManagement.form.Description"),
                    prop: "description",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      autosize: "",
                      type: "textarea",
                      "show-word-limit": "",
                      maxlength: _vm.MAX_LENGTH.DEFAULT,
                      placeholder: _vm.$t("inputText"),
                    },
                    model: {
                      value: _vm.form.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "description", $$v)
                      },
                      expression: "form.description",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDivider", [
        _vm._v(
          _vm._s(_vm.isEdit ? _vm.$t("editText") : _vm.$t("addText")) +
            _vm._s(_vm.$t("WarehouseManagement.form.Bin"))
        ),
      ]),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("WarehouseManagement.form.warehouse"),
                prop: "logicalWarehouseName",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.logicalWarehouseName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "logicalWarehouseName", $$v)
                  },
                  expression: "form.logicalWarehouseName",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }